import HomePage from '../home/HomePage'
import RegisterPageContainer from '../register/RegisterPageContainer'

const routes = {
  '/manage-experiences': () => <HomePage />,
  '/register': () => <RegisterPageContainer />,
}

export default routes
